import axios from "axios";
import baseURL from "../config/api";

export const post_BulkMemberImports = async (
    data: any[],
    userId: number,
    importedBy: string,
    token: string
) => {
    const response = await axios({
        url: `${baseURL}familyMemberImports/CreateBulkFamilyMemberImport`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data,
        params: {
            userId,
            importedBy
        }
    });

    return response.data;
};

export const post_BulkFamilyMemberImports = async (
    data: any[],
    userId: number,
    importedBy: string,
    token: string
) => {
    const response = await axios({
        url: `${baseURL}memberImports/CreateBulkMemberImport`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data,
        params: {
            userId,
            importedBy
        }
    });

    return response.data;
};